import React, {useState} from 'react';
import {TextField} from "@material-ui/core";

export default function TextInput(props) {
    const {
        name,
        label,
        placeholder,
        value,
        onChange,
        error = null,
        onFocus,
        onBlur,
        children,
        ...other
    } = props;

    const [focused, setFocused] = useState(false);
    const hasValue = value !== undefined && value !== null && value !== '';
    // Only forward the placeholder while the field is focused — that way the empty,
    // unfocused state shows the label INSIDE (acting as the placeholder), and the label
    // floats up to the border on focus or once a value is present.
    const showPlaceholder = focused && placeholder && placeholder !== label;

    const handleFocus = (e) => {
        setFocused(true);
        if (onFocus) onFocus(e);
    };

    const handleBlur = (e) => {
        setFocused(false);
        if (onBlur) onBlur(e);
    };

    return (
        <TextField
            variant="outlined"
            label={label}
            placeholder={showPlaceholder ? placeholder : undefined}
            name={name}
            value={value}
            onChange={onChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            InputLabelProps={hasValue ? {shrink: true} : undefined}
            {...(error && {
                error: true,
                helperText: error
            })}
            {...other}
        >
            {children}
        </TextField>
    );
}
